import React, { FC, useEffect, useMemo } from 'react';
import { PageWrapper } from '../../components';
import { paths } from '../../constants/paths';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  fetchAccount,
  getDateFilterValue,
  getDateFilterValueLocal,
  getLoading,
  getSelectedAccount,
  getSelectedProject,
  resetForAccountDetails,
  setSelectedProjectId,
} from '../../redux/account';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { cleanTimeAndPeople } from '../../redux/timeAndPeople';
import { AccountDetailsHeader } from './components/AccountDetailsHeader';
import { getMyPortfolioBreadcrumbs } from '../../features/budgets/AccountsList.utils';
import { AccountDetailsSummary } from './components/AccountDetailsSummary';

export const AccountDetails: FC = () => {
  const { accountId, projectId } = useParams();

  const dispatch = useAppDispatch();
  const location = useLocation();

  const dateFilterValueLocal = useAppSelector(getDateFilterValueLocal);
  const loading = useAppSelector(getLoading);
  const account = useAppSelector(getSelectedAccount);
  const project = useAppSelector(getSelectedProject);
  const dateFilterValue = useAppSelector(getDateFilterValue);

  const breadcrumbs = useMemo(
    () => (account ? getMyPortfolioBreadcrumbs(account, project) : []),
    [project, account],
  );

  useEffect(() => {
    dispatch(resetForAccountDetails());
    if (accountId) {
      if (projectId) dispatch(setSelectedProjectId({ projectId }));
      else dispatch(setSelectedProjectId({ projectId: null }));

      const from = dateFilterValue;
      const to = dateFilterValue;

      dispatch(
        fetchAccount({
          accountId,
          fetchAllMembers: true,

          ...(from &&
            to && {
              periodFiltering: {
                from,
                to,
              },
            }),
        }),
      );
    }
  }, [accountId, dispatch, dateFilterValue, projectId]);

  useEffect(() => {
    return () => {
      dispatch(cleanTimeAndPeople());
    };
  }, [dispatch]);

  const isMarginsDetailsSidebarRequired =
    !location.pathname.includes(paths.forecast) &&
    !location.pathname.includes(paths.sowManagement);

  return (
    <PageWrapper isLoading={loading} sx={{ px: 2, overflow: 'auto', pt: 0 }}>
      <Box sx={{ pt: 4 }}>
        <Breadcrumbs
          showPageLink={true}
          breadcrumbs={breadcrumbs}
          rootPath={paths.portfolio}
          pageName={'Portfolio'}
        />
        {account && (
          <>
            <AccountDetailsHeader
              account={project ? project : account}
              dateFilterValueLocal={dateFilterValueLocal}
            />
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: isMarginsDetailsSidebarRequired
                  ? '1fr 280px'
                  : '1fr',
                gap: 1,
                marginRight: isMarginsDetailsSidebarRequired ? 0 : 1,
              }}
            >
              <Box>
                <Outlet />
              </Box>
              {isMarginsDetailsSidebarRequired && (
                <Box
                  sx={{
                    position: 'sticky',
                    top: 0,
                    alignSelf: 'flex-start',
                    height: 'fit-content',
                  }}
                >
                  <AccountDetailsSummary
                    account={account}
                    projects={project ? [project] : account.projects}
                  />
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>
    </PageWrapper>
  );
};
